import { render, staticRenderFns } from "./uploadReport.vue?vue&type=template&id=ddd64fa8&scoped=true"
import script from "./uploadReport.vue?vue&type=script&lang=js"
export * from "./uploadReport.vue?vue&type=script&lang=js"
import style0 from "./uploadReport.vue?vue&type=style&index=0&id=ddd64fa8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd64fa8",
  null
  
)

export default component.exports